var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcEyeHs(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "46px",
    height: "35px",
    viewBox: "0 0 46 35",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icEyeHS") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M55.8244275,33.5801527 C60.0909326,33.5801527 63.5496183,30.2000734 63.5496183,26.0305344 C63.5496183,21.8609953 60.0909326,18.480916 55.8244275,18.480916 C51.5579224,18.480916 48.0992366,21.8609953 48.0992366,26.0305344 C48.0992366,30.2000734 51.5579224,33.5801527 55.8244275,33.5801527 Z M78.9543701,25.7413265 C75.6947148,15.7273984 66.4697312,9 55.9999495,9 C45.5301677,9 36.305274,15.7273984 33.0456186,25.7413265 C32.9847938,25.928928 32.9847938,26.1321407 33.0456186,26.3197422 C36.305274,36.3336704 45.5302575,43.0610687 56.0000393,43.0610687 C66.4698211,43.0610687 75.6947148,36.3336704 78.95446,26.3197422 C79.015195,26.1321407 79.015195,25.928928 78.9543701,25.7413265 Z M55.8244275,39.1984733 C48.4666559,39.1984733 42.480916,33.291405 42.480916,26.0305344 C42.480916,18.7696637 48.4667452,12.8625954 55.8244275,12.8625954 C63.1821097,12.8625954 69.1679389,18.7696637 69.1679389,26.0305344 C69.1679389,33.291405 63.1821991,39.1984733 55.8244275,39.1984733 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop-HD-header4-Final",
    transform: "translate(-481.000000, -1550.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "LeftSide-Bar",
    transform: "translate(358.000000, 172.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Prospects-V2",
    transform: "translate(0.000000, 528.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Prospects-views---Emp-state",
    transform: "translate(0.000000, 747.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Prospects---Views"
  }, /*#__PURE__*/React.createElement("g", {
    id: "No-matches-yet",
    transform: "translate(90.000000, 94.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "icEyeHS",
    fill: "#CECECE",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEyeHs);
export default __webpack_public_path__ + "static/media/icEyeHS.b5a7a7539ab1f4a3563d5c2bdf692e2d.svg";
export { ForwardRef as ReactComponent };